import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
// ignore-string-externalization
import React from "react";
import dynamic from "next/dynamic";
import { Switch } from "react-router-dom";
import { notFoundRouteConfig } from "@apps/artists-spotify-com-c/src/app/routes/notFoundRouteConfig";
var PageRoute = dynamic(function() {
    return import(/* webpackChunkName: "page-route" */ "./PageRoute");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("./PageRoute")
            ];
        }
    },
    ssr: false
});
export function createPageFromRoutes(routes) {
    var PageRouteToUse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : PageRoute;
    var Page = function Page() {
        var /*#__PURE__*/ _React;
        return (_React = React).createElement.apply(_React, [
            Switch,
            null, 
        ].concat(_to_consumable_array(pageRoutes), [
            /*#__PURE__*/ _jsx(PageRouteToUse, _object_spread({}, notFoundRouteConfig)), 
        ]));
    };
    // eslint-disable-next-line react/jsx-key
    var pageRoutes = routes.map(function(route) {
        return /*#__PURE__*/ _jsx(PageRouteToUse, _object_spread({}, route));
    });
    Page.renderApp = function(param) {
        var Component = param.Component, pageProps = param.pageProps;
        // eslint-disable-next-line new-cap
        return Component(pageProps);
    };
    return Page;
}
export function createPage(route) {
    var PageRouteToUse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : PageRoute;
    return createPageFromRoutes([
        route
    ], PageRouteToUse);
}
